(() => {
  const badgeClass = 'vh-variant-sale-badge';
  let queued = false;

  function update() {
    queued = false;
    const product = window.__productWizRioProduct;
    if (!product?.variants?.length || !product.options) return;

    const selectedId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const selectedVariant = product.variants.find(variant => String(variant.id) === selectedId)
      || product.variants.find(variant => String(variant.id) === new URLSearchParams(location.search).get('variant'))
      || product.variants[0];

    document.querySelectorAll('.rio-options').forEach(root => {
      // Read the app's displayed selection, including while it updates the theme form.
      const selectedOptions = [...selectedVariant.options];
      root.querySelectorAll('[data-option]').forEach(group => {
        const index = product.options.findIndex(option => (option.name || option) === group.dataset.option);
        let container = group.parentElement;
        let title;
        while (container && root.contains(container)) {
          title = container.querySelector('.rio-product-option-title-option-value');
          if (title || container.querySelectorAll('[data-option]').length > 1) break;
          container = container.parentElement;
        }
        if (index >= 0 && title) selectedOptions[index] = title.textContent.trim();
      });

      root.querySelectorAll('[data-option-value]').forEach(choice => {
        const group = choice.closest('[data-option]');
        const index = product.options.findIndex(option => (option.name || option) === group?.dataset.option);
        const onSale = index >= 0 && product.variants.some(variant =>
          Number(variant.compare_at_price) > Number(variant.price)
          && variant.options.every((value, optionIndex) =>
            value === (optionIndex === index ? choice.dataset.optionValue : selectedOptions[optionIndex]))
        );
        const existing = choice.querySelector(`:scope > .${badgeClass}`);
        if (onSale && !existing) {
          const badge = document.createElement('span');
          badge.className = badgeClass;
          badge.textContent = '%';
          badge.setAttribute('aria-hidden', 'true');
          choice.appendChild(badge);
        } else if (!onSale && existing) {
          existing.remove();
        }
        // Keep the app's label intact and add an accessible sale description.
        const descriptions = (choice.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        const next = descriptions.filter(id => id !== 'vh-variant-sale-description');
        if (onSale) next.push('vh-variant-sale-description');
        if (next.join(' ') !== descriptions.join(' ')) {
          if (next.length) choice.setAttribute('aria-describedby', next.join(' '));
          else choice.removeAttribute('aria-describedby');
        }
      });
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  function init() {
    const main = document.querySelector('main');
    if (!main) return;
    const description = document.createElement('span');
    description.id = 'vh-variant-sale-description';
    description.className = 'visually-hidden';
    description.textContent = document.documentElement.lang.startsWith('de') ? 'Im Angebot' : 'On sale';
    main.appendChild(description);

    const observer = new MutationObserver(records => {
      if (records.some(record => {
        if (record.target.closest?.(`.${badgeClass}`)) return false;
        if (record.type === 'childList' && [...record.addedNodes, ...record.removedNodes].every(node =>
          node.nodeType === 1 && node.classList.contains(badgeClass))) return false;
        return true;
      })) schedule();
    });
    observer.observe(main, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['data-option', 'data-option-value', 'aria-label'] });
    main.addEventListener('change', schedule);
    window.addEventListener('popstate', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
